module.exports = __webpack_public_path__ + "static/media/envalopSidebar.b79628f9.svg";